var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { supportContactInformation } from '@/constants/support.constant';
import { Link } from '@mui/material';
import { cn } from 'hx-util';
import { FaPhone } from 'react-icons/fa6';
export function CallSupport(_a) {
    var _b = _a.phoneNumber, phoneNumber = _b === void 0 ? supportContactInformation.phone.number : _b, _c = _a.phoneNumberHref, phoneNumberHref = _c === void 0 ? supportContactInformation.phone.href : _c, _d = _a.iconColor, iconColor = _d === void 0 ? 'white' : _d, classes = _a.classes, onClick = _a.onClick;
    var _e = classes || {}, containerClass = _e.containerClass, iconClass = _e.iconClass, textClass = _e.textClass;
    return (_jsxs(Link, __assign({ href: phoneNumberHref, onClick: onClick, className: cn('flex gap-4 w-fit align-middle items-center justify-center no-underline', containerClass), target: "_blank" }, { children: [_jsx("div", __assign({ className: cn('flex h-8 w-8 items-center rounded-full bg-eargo-sinopia px-2 py-1.5', iconClass) }, { children: _jsx(FaPhone, { color: iconColor }) })), _jsxs("p", __assign({ className: cn('text-lg mt-1 text-eargo-night', textClass) }, { children: [_jsx("strong", { children: "Call Support" }), phoneNumber] }))] })));
}
